<template>
  <div class="frameParent" v-if="student && grades">
    <div class="frameParent1">
      <div class="frameParent2">
        <div class="frameParent3">
          <img class="frameItem" alt="" :src="student.image" />
          <div class="textParent">
            <b class="text">{{ student.firstName }} {{ student.lastName }}</b>
            <div class="youreInGradeBookParent">
              <b
                >Current Grade:
                <span :class="grades.gradeClass"
                  >{{ grades.averageGrade.toFixed(2) }}%</span
                >
              </b>
            </div>
            <div
              class="switchToLogBookWrapper"
              v-if="currenUser.id === student.id"
            >
              <div class="selected">Grade Book</div>
              <div class="unselected" @click="goToLogBook">Log Book</div>
            </div>
          </div>
        </div>
        <!--        <div class="frameWrapper">
          <div class="frameParent4">
            <div class="frameInner" />
            <div class="frameChild1" />
            <div class="frameChild2" />
            <div class="frameChild3" />
          </div>
        </div>
        <div class="frameParent5">
          <div class="frameParent6">
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Hours: 200</div>
            </div>
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total PIC: 200</div>
            </div>
          </div>
          <div class="frameParent6">
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Dual: 200</div>
            </div>
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total IFR: 200</div>
            </div>
          </div>
          <div class="frameParent6">
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Day: 200</div>
            </div>
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Night: 200</div>
            </div>
          </div>
          <div class="frameParent6">
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Ground: 200</div>
            </div>
            <div class="totalHours200Wrapper">
              <div class="flightReview">Total Sim: 200</div>
            </div>
          </div>
        </div>-->
      </div>
      <!--      <div class="frameParent10">
        <div class="frameParent11">
          <img class="frameIcon" alt="" src="Frame 599.png" />
          <div class="n2361rParent">
            <div class="n2361r">N2361R</div>
            <div class="pa28180">PA-28-180</div>
          </div>
          <div class="az39KffzParent">
            <div class="keatonHarris">AZ39 - KFFZ</div>
            <div class="keatonHarris">April 25, 2024</div>
            <div class="keatonHarris">1.8 Hours Total</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 13.svg" />
        <div class="frameParent11">
          <img class="frameIcon" alt="" src="Frame 604.png" />
          <div class="n2361rParent">
            <div class="n2361r">N2361R</div>
            <div class="pa28180">PA-28-180</div>
          </div>
          <div class="az39KffzParent">
            <div class="keatonHarris">AZ39 - KFFZ</div>
            <div class="keatonHarris">April 25, 2024</div>
            <div class="keatonHarris">1.8 Hours Total</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 12.svg" />
        <div class="frameParent11">
          <img class="frameIcon" alt="" src="Frame 604.png" />
          <div class="n2361rParent">
            <div class="n2361r">N2361R</div>
            <div class="pa28180">PA-28-180</div>
          </div>
          <div class="az39KffzParent">
            <div class="keatonHarris">AZ39 - KFFZ</div>
            <div class="keatonHarris">April 25, 2024</div>
            <div class="keatonHarris">1.8 Hours Total</div>
          </div>
        </div>
      </div>
      <div class="frameParent14">
        <div class="currencyReviewWrapper">
          <b class="currencyReview">Currency Review</b>
        </div>
        <img class="frameChild4" alt="" src="Vector 13.svg" />
        <div class="frameParent15">
          <div class="flightReviewParent">
            <div class="flightReview">Flight Review</div>
            <div class="flightReview">365 Days</div>
          </div>
          <div class="currentParent">
            <div class="flightReview">Current</div>
            <div class="remaining">Remaining</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 14.svg" />
        <div class="frameParent15">
          <div class="flightReviewParent">
            <div class="flightReview">Landings</div>
            <div class="flightReview">365 Days</div>
          </div>
          <div class="currentParent">
            <div class="flightReview">Current</div>
            <div class="remaining">Remaining</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 15.svg" />
        <div class="frameParent15">
          <div class="flightReviewParent">
            <div class="flightReview">IFR (Airplane)</div>
            <div class="flightReview">365 Days</div>
          </div>
          <div class="currentParent">
            <div class="flightReview">Current</div>
            <div class="remaining">Remaining</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 16.svg" />
        <div class="frameParent15">
          <div class="flightReviewParent">
            <div class="flightReview">Medical Approval</div>
            <div class="flightReview">365 Days</div>
          </div>
          <div class="currentParent">
            <div class="flightReview">Current</div>
            <div class="remaining">Remaining</div>
          </div>
        </div>
        <img class="frameChild4" alt="" src="Vector 17.svg" />
        <div class="frameParent15">
          <div class="flightReviewParent">
            <div class="flightReview">General (ASEL)</div>
            <div class="flightReview">126</div>
          </div>
          <div class="currentParent">
            <div class="flightReview">Hours flown in the last 90 days</div>
            <div class="remaining">Total</div>
          </div>
        </div>
      </div>
      <div class="eparrowUpBoldWrapper">
        <img class="eparrowUpBoldIcon" alt="" src="ep:arrow-up-bold.png" />
      </div>-->
    </div>
    <div class="tableContainer" v-if="grades">
      <div class="tableBorderWrapper">
        <div class="tableWrapper">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Section Title</th>
                <th>Type</th>
                <th>Num.</th>
                <th class="blueHeader">Class Average</th>
                <th class="orangeHeader">
                  {{ student.firstName }} {{ student.lastName }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="assignment of grades.studentAssignments"
                v-bind:key="assignment.assignment.id"
              >
                <td class="greyHeader">
                  {{ assignment.assignment.dueDate.format("MM/DD") }}
                </td>
                <td class="greyHeader">{{ assignment.assignment.name }}</td>
                <td class="greyHeader">
                  {{ assignment.assignment.assignmentType.name }}
                </td>
                <td class="greyHeader">{{ assignment.assignment.number }}</td>
                <td class="blueHeader">
                  {{ assignment.assignment.classAverage }}%
                </td>
                <td>
                  <span v-if="isNaN(assignment.gradePercentage)" class="noClick"
                    >-</span
                  >
                  <span
                    v-else
                    class="gradePercentage"
                    @click="goToAssignment(assignment)"
                    :class="!assignment.assignment.graded ? 'notGraded' : ''"
                  >
                    {{ assignment.gradePercentage.toFixed(1) }}%
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <toast-notifier ref="toast"></toast-notifier>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { useLoginStore } from "../../../../stores/loginStore";
import { getProcessedImageUrl } from "../../../../util/images";
import UsersAPIService from "../../../../servicehandlers/UsersAPIService";
import ActiveStudentsAPIService from "../../../../servicehandlers/ActiveStudentsAPIService";
import toastNotifier from "../../../../components/ToastNotifier.vue";

const userAPIService = new UsersAPIService();
const activeStudentAPIService = new ActiveStudentsAPIService();
export default {
  name: "SingleStudentGradeBook",
  components: { toastNotifier },
  data() {
    return {
      currenUser: null,
      student: null,
      grades: null,
    };
  },
  async mounted() {
    this.currenUser = this.useLoginStore().getUser;
    let admin = false;
    for (let authGroup of this.currenUser.auth_groups) {
      for (let scope of authGroup.scopes) {
        if (scope.name === "full-gradebook") {
          admin = true;
        }
      }
    }
    if (this.$route.query.studentId) {
      if (admin) await this.getStudent();
    } else {
      this.student = this.currenUser;
    }
    this.student.image = this.getProcessedImageUrl(this.student.image);
    await this.getStudentGrades();
  },
  methods: {
    useLoginStore,
    getProcessedImageUrl,
    getStudent() {
      return userAPIService
        .getById(this.$route.query.studentId, this.$router)
        .then((response) => {
          this.student = response;
        });
    },
    getStudentGrades() {
      return activeStudentAPIService
        .getStudentGradeDetails(this.student.id, this.$router)
        .then((response) => {
          this.grades = response;
          for (let assignment of this.grades.studentAssignments) {
            assignment.assignment.dueDate = dayjs(
              assignment.assignment.dueDate,
            );
          }
          this.grades.gradeClass = this.gradeColor();
        });
    },
    gradeColor() {
      if (this.grades.averageGrade >= 90) {
        return "greenText";
      } else if (
        this.grades.averageGrade < 90 &&
        this.grades.averageGrade >= 80
      ) {
        return "LightGreenText";
      } else if (
        this.grades.averageGrade < 80 &&
        this.grades.averageGrade >= 70
      ) {
        return "yellowText";
      } else if (
        this.grades.averageGrade < 70 &&
        this.grades.averageGrade >= 60
      ) {
        return "orangeText";
      } else {
        return "redText";
      }
    },
    goToLogBook() {
      this.$router.push({
        name: "Logbook",
      });
    },
    goToAssignment(assignment) {
      let name = "";
      let query = {
        assignmentId: assignment.assignment.id,
      };
      let go = false;
      if (this.currenUser.id !== this.student.id) {
        name = "Graded";
        query.studentId = this.student.id;
        if (assignment.completed) {
          go = true;
        }
      } else if (assignment.completed) {
        name = "Graded";
        go = true;
      } else {
        name = "Take";
        go = true;
      }

      if (go) {
        this.$router.push({
          name: name + " Assignment",
          query,
        });
      } else {
        this.$refs.toast.showInfo("No student submission for assignment");
      }
    },
  },
};
</script>
<style scoped>
.notGraded {
  position: relative;
  cursor: pointer;
  color: rgba(0, 0, 0, 50%);
}

.notGraded:hover::after {
  content: "Doesn't Effect Grade";
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
  opacity: 150%;
  visibility: visible;
}
.notGraded::after {
  content: "";
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s;
}
.greenText {
  color: #00a551;
}
.LightGreenText {
  color: #5ed053;
}
.yellowText {
  color: #eece01;
}
.orangeText {
  color: #da7704;
}
.redText {
  color: #ba0000;
}
.switchToLogBookWrapper {
  background-color: #dddddd;
  border-radius: 12px;
  font-size: 20px;
  display: flex;
  gap: 10px;
}
.selected {
  background-color: #3c78ff;
  border-radius: 12px;
  color: white;
  padding: 2px 7px;
}
.unselected {
  padding: 2px 7px;
  cursor: pointer;
}
.tableContainer {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start; /* Aligns content to the left */
  padding: 0 50px;
}

.tableWrapper {
  overflow-x: auto;
  display: block;
  width: auto; /* Ensures the table only takes up the necessary width */
  max-width: fit-content; /* Prevents it from stretching */
}

table {
  max-width: 100%;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  border: none !important;
}

th,
td {
  border: 1px solid #929292;
  padding: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 400 !important;
}

th {
  background-color: #696969;
  color: white;
  font-weight: bold;
  border-right: #696969 1px solid;
  border-top: none;
  border-bottom: none;
  border-left: none;
}

th.blueHeader {
  background-color: #3c78ff;
  border-right: #3c78ff 2px solid;
  text-align: center;
  position: sticky;
  left: var(--name-column-width); /* Dynamically position Grade */
  z-index: 2;
}

th.orangeHeader,
td.orangeHeader {
  background-color: #ff8800;
  border-right: #d97400 1px solid;
  border-left: #d97400 1px solid;
  border-top: none;
  border-bottom: none;
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 150px !important;
  max-width: 150px !important;
}

th.orangeHeader:first-child {
  border-left: none;
}

td.blueHeader {
  background-color: #f4f7ff;
  text-align: center;
  position: sticky;
  left: var(--name-column-width); /* Dynamically position Grade */
  z-index: 2;
}

td.greyHeader {
  background-color: #e3e3e3;
  border-left: 1px solid #929292;
  white-space: nowrap;
  text-align: left;
  padding: 5px 10px;
}

td {
  font-size: 14px;
  border-top: none;
  border-bottom: 1px solid #929292;
  padding: 5px 7.5px;
  text-align: center;
}

th:first-child {
  border-top-left-radius: 10px;
  border-left: none;
}

th:last-child {
  border-top-right-radius: 10px;
  border-right: none;
}

tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

th:nth-child(2),
td:nth-child(2) {
}

.gradePercentage {
  cursor: pointer;
}
.gradePercentage:hover {
  text-decoration: underline;
}

th:first-child,
td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

.noClick {
  cursor: not-allowed;
}

.tableBorderWrapper {
  border-radius: 10px;
  overflow: hidden;
  max-width: 100%;
}
.frameItem {
  width: 100px;
  border-radius: 15px;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
}
.text {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.youreInGradeBookParent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
  font-size: 24px;
}
.textParent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.frameParent3 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}
.frameParent2 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  z-index: 0;
}
.frameParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  position: relative;
  gap: 40px;
  z-index: 2;
  font-size: 40px;
}
.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
